import router from './router';
import store from './store';

import { setDocumentTitle, domTitle } from '@/utils/domUtil';
import { isSessionExpiredError } from '@/utils/session';

const whiteList = ['Root', 'Index', 'WxLogin', 'ContractCheck', 'other', '404']; // no redirect whitelist

const isPublicRoute = (route) => whiteList.includes(route.name);

// Expiry can be detected by any request while a protected page is already open.
store.watch((state) => state.user.sessionTimeout, (expired) => {
  if (!expired || isPublicRoute(router.currentRoute)) return;
  store.commit('user/SET_LOGINFLAG', true);
  const navigation = router.replace({ path: '/index' });
  if (navigation && navigation.catch) navigation.catch(() => {});
});

router.beforeEach(async (to, from, next) => {
  to.meta &&
    typeof to.meta.title !== 'undefined' &&
    setDocumentTitle(`${domTitle}`);
  if (isPublicRoute(to)) {
    next();
    return;
  }
  if (!store.getters.getToken) {
    store.commit('user/SET_LOGINFLAG', true);
    next({ path: '/index', replace: true });
    return;
  }
  const version = store.state.user.sessionVersion;
  try {
    // A cached profile does not prove that another login has not replaced us.
    if (store.getters.login) await store.dispatch('user/checkSession');
    else await store.dispatch('user/getUserInfoAction');
    if (store.getters.getToken && store.getters.login) next();
    else {
      store.commit('user/SET_LOGINFLAG', true);
      next({ path: '/index', replace: true });
    }
  } catch (error) {
    if (version !== store.state.user.sessionVersion && store.getters.getToken) {
      // A response from an earlier account cannot dismiss a newer login.
      next(false);
      return;
    }
    if (isSessionExpiredError(error) || !store.getters.getToken) {
      store.commit('user/SET_LOGINFLAG', true);
      next({ path: '/index', replace: true });
    } else next(false);
  }
});
